<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="450">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input" @submit.prevent="submitForm">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4 v-if="type">Update "{{ type.short_name }}" Sim Card Type</h4>
                    <h4 v-else>New Sim Card Type</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData['short_name']" autofocus
                                          :rules="[vRules.required,vRules.maxLength(20)]"
                                          density="compact" label="Short Name"/>
                            <v-text-field v-model="formData['vendor_name']"
                                          :rules="[vRules.required,vRules.maxLength(30)]"
                                          density="compact" label="Vendor Name"/>
                            <v-text-field v-model="formData['description']"
                                          :rules="[vRules.maxLength(60)]"
                                          density="compact" label="Description"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    type: Object,
});
const formData = reactive({
    valid: false,
    short_name: props.type?.short_name ?? null,
    vendor_name: props.type?.vendor_name ?? null,
    description: props.type?.description ?? null,
});
const emits = defineEmits(['update:modelValue', 'addType', 'updateType']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);

const submitForm = () => {
    errors.value = [];
    send(`${props.type ? 'put' : 'post'}`,
        `admin/sim-card-types${props.type ? '/' + props.type.id : ''}`,
        formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits(props.type ? 'updateType' : 'addType', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response?.data?.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response?.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
